import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import s from './FAQ.style';

// Answers are always rendered in the DOM (hidden via CSS when collapsed) so
// crawlers and the prerenderer see the full FAQ content that the FAQPage
// schema on the homepage references.
const FAQ_ITEMS = [
  {
    question: 'Mennyibe kerül egy alkalmi smink?',
    answer:
      'Az alkalmi smink ára 20 000 Ft. Ide tartozik a nappali smink, esti smink, szalagavató smink, valamint smink fotózásra és fitness versenyre. A műszempilla felhelyezése feláras.',
  },
  {
    question: 'Mennyibe kerül egy esküvői smink és mit tartalmaz?',
    answer:
      'Az esküvői smink csomag ára 60 000 Ft, ami tartalmazza a részletes konzultációt, próbasminket a stúdióban, sminket az esküvő napján, a vőlegény arcának lemattítását, valamint Budapest területén kiszállást.',
  },
  {
    question: 'Mennyi ideig tart egy önsminkelő oktatás?',
    answer:
      'Az egyéni sminktanácsadás és oktatás körülbelül 3-4 órás, személyre szabott alkalom. Az ára 45 000 Ft, és tartalmaz bőrápolási konzultációt, neszesszer átnézést, sminktechnikák elsajátítását, valamint egy online sminknaplót képekkel és magyarázatokkal.',
  },
  {
    question: 'Hol található a The Makeup Lab stúdió?',
    answer:
      'A stúdió Budapest belvárosában, az V. kerületben található: 1054 Budapest, Hold utca 21. Könnyen megközelíthető tömegközlekedéssel (M2, M3 metró, 70-es, 78-as troli, 2, 2B, 23-as villamos). Autóval is elérhető, fizetős parkolással (kód: 0501).',
  },
  {
    question: 'LMBTQ-barát a The Makeup Lab?',
    answer:
      'Igen, a The Makeup Lab egy befogadó, LMBTQ+ barát stúdió Budapesten. Mindenkit szeretettel várunk, függetlenül nemi identitástól vagy szexuális orientációtól. A szolgáltatások személyre szabottak, és az alkalmak mindig Rólad szólnak.',
  },
  {
    question: 'Lehet kutyát vagy háziállatot hozni a stúdióba?',
    answer: 'Igen, a The Makeup Lab állatbarát, kutyabarát stúdió. Szívesen látjuk a szőrös családtagokat is!',
  },
];

class FAQ extends Component {
  state = {
    openFaq: null,
  };

  toggleFaq = index => {
    this.setState(prevState => ({
      openFaq: prevState.openFaq === index ? null : index,
    }));
  };

  render() {
    return (
      <div className={css(s.faqSection)}>
        <h2 className={css(s.faqTitle)}>Gyakran Ismételt Kérdések</h2>
        <div className={css(s.faqInner)}>
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = this.state.openFaq === index;
            return (
              <div className={css(s.faqItem)} key={index}>
                <div
                  className={css(s.faqQuestion)}
                  onClick={() => this.toggleFaq(index)}
                  role="button"
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <span className={css(s.faqIcon)}>{isOpen ? '-' : '+'}</span>
                </div>
                <div className={css(s.faqAnswer, !isOpen && s.faqAnswerHidden)}>
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default FAQ;
